export interface BrandingConfig {
    productName: string;
    productShortName: string;
    workspaceLabel: string;
    logo: {
        lockupDark: string;
        lockupLight: string;
        markDark: string;
        markLight: string;
        alt: string;
        markText: string;
    };
    favicon: string;
    meta: {
        title: string;
        description: string;
    };
    colors: {
        primary: string;
        primaryForeground: string;
        sidebarPrimary: string;
        sidebarPrimaryForeground: string;
    };
}

export const branding: BrandingConfig = {
    productName: 'Invisible API',
    productShortName: 'Invisible',
    workspaceLabel: 'Organization',
    logo: {
        lockupDark: '/branding/logo-dark.svg',
        lockupLight: '/branding/logo-light.svg',
        markDark: '/branding/mark-dark.svg',
        markLight: '/branding/mark-light.svg',
        alt: 'Invisible API logo',
        markText: 'I'
    },
    favicon: '/branding/favicon.svg',
    meta: {
        title: 'Invisible API',
        description: 'A reusable SaaS base application for building branded admin platforms.'
    },
    colors: {
        primary: 'oklch(0.205 0 0)',
        primaryForeground: 'oklch(0.985 0 0)',
        sidebarPrimary: 'oklch(0.205 0 0)',
        sidebarPrimaryForeground: 'oklch(0.985 0 0)'
    }
};
